import { persistStore } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
import { store } from 'store';

export { history, reducer, store } from 'store';

export const persistor = persistStore(store);

/*
const persistConfig = {
  key: 'root',
  version: 1,
  whitelist: [],
  storage,
};



if (module.hot) {
  module.hot.accept('../../reducer', () => {
    // eslint-disable-next-line
    const nextRootReducer = require('../../reducer');
    store.replaceReducer(persistReducer(persistConfig, nextRootReducer));
  });
}
*/
